export type OrderOptimizerDetailsOtherStepsOrdersPoints = {
  displayName: string;
  time: Date;
  haltingTime: number;
  distance: number;
  driverTime: Date | null;
  driverHaltingTime: number;
  driverDrivingTime: number;
  driverDistance: number;
  lat: number;
  lon: number;
};

export type OrderOptimizerDetailsOtherStepsEndToHome = {
  displayName: string;
  driverTime: Date;
  driverDrivingTime: number;
  driverDistance: number;
};

export type OrderOptimizerDetailsOtherStepsOrders = {
  points: OrderOptimizerDetailsOtherStepsOrdersPoints[];
  totalTime: number;
  haltingTime: number;
  distance: number;
};

export type OrderOptimizerDetailsOtherStepsHomeToStart = {
  displayName: string;
  driverTime: Date;
};

export type OrderOptimizerDetailsOtherSteps = {
  homeToStart: OrderOptimizerDetailsOtherStepsHomeToStart | null;
  orders: OrderOptimizerDetailsOtherStepsOrders[];
  endToHome: OrderOptimizerDetailsOtherStepsEndToHome | null;
};

export type OrderOptimizerDetailsOtherOrdersByDriverSabs = {
  totalTime: number;
  haltingTime: number;
  distance: number;
};

export type OrderOptimizerDetailsOtherOrdersByDriverAba = {
  totalTime: number;
  haltingTime: number;
  distance: number;
};

export type OrderOptimizerDetailsOtherDriver = {
  driverId: string;
  displayName: string;
  taxiCorporation: string;
  startLat: number;
  startLon: number;
  contractRate: number;
};

export type OrderOptimizerDetailsOtherOptimizedStats = {
  contractRate: number;
  totalTime: number;
  haltingTime: number;
  distance: number;
  margin: number;
};

export type OrderOptimizerDetailsOtherUnoptimizedStats = {
  contractRate: number;
  totalTime: number;
  haltingTime: number;
  distance: number;
  margin: number;
};

export type OrderOptimizerDetailsOtherOrders = {
  humanId: number;
  cargoCompany: string;
  billingModel: string;
  taxiCorporation: string;
  totalTime: number;
  haltingTime: number;
  distance: number;
  startTime: Date;
  planEntryHumanId: number | null;
  driverName: string | null;
  fleetPartner: string | null;
};

export enum OrderOptimizerDetailsOtherStatus {
  PENDING = "PENDING",
  INTERESTING = "INTERESTING",
  REJECTED = "REJECTED",
}

type OrderOptimizerDetailsOther = {
  reviewedBy: string | null;
  reviewedAt: Date | null;
  orders: OrderOptimizerDetailsOtherOrders[];
  unoptimizedStats: OrderOptimizerDetailsOtherUnoptimizedStats;
  optimizedStats: OrderOptimizerDetailsOtherOptimizedStats;
  driver: OrderOptimizerDetailsOtherDriver | null;
  ordersByDriverAba: OrderOptimizerDetailsOtherOrdersByDriverAba | null;
  ordersByDriverSabs: OrderOptimizerDetailsOtherOrdersByDriverSabs | null;
  saAndBsDistance: number;
  steps: OrderOptimizerDetailsOtherSteps;
  score: number;
  status: OrderOptimizerDetailsOtherStatus;
  totalCargoIncome: number;
  totalDriverHaltingCost: number;
};

export default OrderOptimizerDetailsOther;
